var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"disabled":"","label":_vm.label || _vm.keyAttr,"loading":_vm.isCompletudeRequired(_vm.bindAttribute, _vm.currentIssues)},model:{value:(_vm.item[_vm.property][_vm.keyAttr]),callback:function ($$v) {_vm.$set(_vm.item[_vm.property], _vm.keyAttr, $$v)},expression:"item[property][keyAttr]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }